module.exports = __webpack_public_path__ + "img/sprinkle-26.33683351.jpg";